import http from "@/assets/js/http.js";
import modal from "@/assets/js/modal.js";

const state = () => ({
    filter: {
        page: 1,
        per_page: 10,
        keyword: null,
        requested: false,
        restricted: null,
        id_perusahaan: [],
    },
    response: {
        data: [],
        meta: [],
        filter: {
            perusahaans: [],
            depos: [],
            salesmans: [],
        },
    },
    modal: {
        filter: {
            backdrop: false,
            modal: false,
            data: {},
        }
    },
})

const mutations = {
}

const actions = {
    triggerModal({ state }, payload) {
        return modal.trigger(state, payload)
    },
    getLimitKredit({ state }, payload = null) {
        return http.get('toko/limit_kredit', state, payload)
    },
    updateLimitKredit({ dispatch, state }, payload = null) {
        return http.post('toko/limit_kredit/update', state, payload, dispatch, 'getLimitKredit')
    },
    updateLimitKreditBulk({ dispatch, state }, payload = null) {
        return http.post('toko/limit_kredit/update/' + payload, state, null, dispatch, 'getLimitKredit')
    },
    updateExcelLimitKredit({ dispatch, state }, payload = null) {
        return http.post('import/update_limit', state, payload, dispatch, 'getLimitKredit')
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
